import * as R from 'ramda'
import effects from 'app/effects/effects'
import {
  pickUserProfileApi,
  mapEmptyPhoneNumber,
} from 'app/main/userProfile/UserProfileMapper'
import { useDispatch } from 'react-redux'
import { UPDATE_USER_DATA } from 'app/auth/store/actions'
import { useResultDispatch } from 'commons/useResultDispatch'
import { useIntl } from 'react-intl'
import { useConversationSocket } from 'app/main/messages/conversations/useConversationSocket'
import { SocketEvent } from 'app/main/messages/conversations/socket'

export const submitAdminProfileEffect = R.compose(
  effects.apis.updateAdminProfile,
  pickUserProfileApi,
  mapEmptyPhoneNumber,
)

export const useOnUpdateAdminProfileSuccess = () => {
  const dispatch = useDispatch()
  const { dispatchError, dispatchSuccess } = useResultDispatch()
  const { formatMessage } = useIntl()
  const { handleRecordUpdates } = useConversationSocket()
  const onUpdateAdminProfileSuccess = () => {
    dispatchSuccess(formatMessage({ id: 'adminProfile.result.success' }))
    effects.apis
      .getAdminProfile()
      .then((profile) => {
        handleRecordUpdates(SocketEvent.UPDATE_TEAM_MEMBER, profile.id)
        dispatch({
          type: UPDATE_USER_DATA,
          payload: profile,
        })
      })
      .catch(dispatchError)
  }
  return onUpdateAdminProfileSuccess
}

export const useRreloadProfile = () => {
  const dispatch = useDispatch()
  const { dispatchError } = useResultDispatch()
  const { handleRecordUpdates } = useConversationSocket()
  const onReloadProfile = () => {
    effects.apis
      .getAdminProfile()
      .then((profile) => {
        handleRecordUpdates(SocketEvent.UPDATE_TEAM_MEMBER, profile.id)
        dispatch({
          type: UPDATE_USER_DATA,
          payload: profile,
        })
      })
      .catch(dispatchError)
  }
  return onReloadProfile
}
